"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Position = void 0;
const Position = {
  TOP: 'top',
  CENTER: 'center',
  BOTTOM: 'bottom'
};
exports.Position = Position;